/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable')
    .directive('accEmptyTableRow', [function() {
        return {
            scope: true,
            replace: true,
            template: function(element, attributes) {
                return '<tr ng-if="table.entries.length <= 0">\
                                        <td colspan="{{table.columnCount()}}">\
                                            <p class="text-center">' + attributes['accEmptyTableRow'] + '</p>\
                                        </td>\
                                    </tr>';
                }
            }
        }
    ]);
